<template>
  <distributions-list />
</template>

<script>
import DistributionsList from "./DistributionsList.vue"

export default {
  name: "DistributionsListPage",
  components: {
    DistributionsList,
  },
}
</script>
